import * as React from 'react'
import { useState } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

import { useRollback } from './hooks'
import { setRollback, submitRollback } from './model'
import {
  CButton,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import { transactionRequestDestinationType } from '../../../const'
import { Alert, Button, Divider, Tag } from 'antd'
import { InternalTransferEdit } from '../../list/types'

type Props = {
  request: InternalTransferEdit
  className?: string
  color?: string
  disabled?: boolean
}

export const RollbackModal = ({ request, className, disabled }: Props) => {
  const { rollback, isLoading } = useRollback()
  const [isVisible, setVisible] = React.useState(false)
  const ref = React.useRef(null)

  useOnClickOutside(ref, () => {
    if (isVisible) {
      setRollback('')
    }
  })

  const [reason, setReason] = useState('')

  // @ts-ignore
  return (
    <>
      <Button
        type="primary"
        className={className}
        onClick={() => setVisible(true)}
        disabled={disabled}
      >
        Rollback
      </Button>
      <CModal visible={isVisible} onClose={() => setVisible(false)} size={'xl'}>
        <CForm
          className="row g-3 needs-validation"
          noValidate
          onSubmit={(e) => {
            const form = e.currentTarget
            if (rollback.length == 0) {
              setReason('Please enter a reason')
              e.preventDefault()
              e.stopPropagation()
              return
            }
            e.preventDefault()
            setReason('')
            submitRollback({
              requestId: request.transferId,
              // @ts-ignore
              rollbackReason: rollback,
            })
            setVisible(false)
          }}
          id="rollbackForm"
        >
          <CModalHeader>
            <CModalTitle>Set reason</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {reason.length > 0 && <Alert message={reason} type={'error'} />}
            <CFormLabel htmlFor="initialAmount" className="col-12">
              Rollback reason
            </CFormLabel>
            <CFormInput
              type="text"
              id="reason"
              name="reason"
              onChange={(e) => {
                setRollback(e.target.value)
              }}
            />
            <CFormFeedback invalid>Field is required</CFormFeedback>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setVisible(false)}>
              Cancel
            </CButton>
            <CButton
              color="primary"
              className="px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Rollback
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}
